import React, { Component } from 'react';
import { Table, ConfigProvider, Button, Upload, message } from 'antd';
import './list.css'
import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'
import { RootState } from '../../../../core/reducers';
import { Link, RouteComponentProps } from 'react-router-dom';
import {
    actionGetExamineeList,
    actionGetExamineeExcelTemplate,
    actionImportExamineesFromExcel,
} from '../../../../core/actions/silizhu/examinee';
import moment from 'moment'
import SearchForm from './searchForm'
import { withTranslation, WithTranslationProps } from 'react-i18next'
import enUs from 'antd/lib/locale/en_US';
import zhCN from 'antd/lib/locale/zh_CN';
import { UploadOutlined } from '@ant-design/icons';

interface StateProps {
    examineeList: any
    examineeExcelTemplate: any
    routeKey: any
}

interface DispatchProps {
    getExamineeList(data): void
    getTemplate(): void
    importExaminee(data): void
}

interface RouteState {
    tag: string
}

type TypeProps = StateProps & RouteComponentProps<RouteState>;

class Index extends Component<TypeProps & DispatchProps & WithTranslationProps> {

    Columns;
    constructor(props) {
        super(props)
    }

    returnColumns = () => {
        const i18n = this.props.i18n;
        this.Columns = [
            {
                title: i18n?.t('name'),
                dataIndex: 'nickname',
                key: 'nickname'
            },
            {
                title: i18n?.t('gender'),
                dataIndex: 'gender',
                key: 'gender',
                render: (text) => {
                    if (text === "MALE") {
                        return i18n?.t('male')
                    }
                    else if(text === "FEMALE") {
                        return i18n?.t('female')
                    }
                    else return ""
                }
            },
            {
                title: i18n?.t('age'),
                dataIndex: 'birthTime',
                key: 'birthTime',
                render: (text) => {
                    let birthDayTime = (new Date(text)).getTime();
                    if(birthDayTime > 0) {
                        let nowTime = new Date().getTime();
                        return Math.floor((nowTime - birthDayTime) / 31536000000);
                    }
                    else return ""
                }
            },
            {
                title: i18n?.t('height'),
                dataIndex: 'height',
                key: 'height',
                render: (text) => {
                    if(text) {
                        return <span>{text} cm</span>
                    }
                    else return ""
                }
            },
            {
                title: i18n?.t('weight'),
                dataIndex: 'weight',
                key: 'weight',
                render: (text) => {
                    if(text) {
                        return <span>{text} kg</span>
                    }
                    else return ""
                }
            },
            {
                title: i18n?.t('contactWay'),
                render: (record) => {
                    let text = '';
                    if (record.mobileNumber) {
                        text = record.mobileNumber;
                    }
                    else if (record.email) {
                        text = record.email;
                    }
                    return <span>{text}</span>
                }
            },
            {
                title: i18n?.t('remark'),
                dataIndex: 'description',
                key: 'description'
            },
            {
                title: i18n?.t('newDetectionTime'),
                dataIndex: 'latestTime',
                key: 'latestTime',
                render: (text) => {
                    if (text) {
                        let end = (new Date(text)).valueOf();
                        let time = moment(end).format('YYYY-MM-DD HH:mm:ss')
                        return <span>{text && time}</span>
                    }
                }
            },
            {
                title: i18n?.t('detectionCount'),
                dataIndex: 'count',
                key: 'count',
            },
            {
                title: i18n?.t('more'),
                render: (record) => {
                    let routeKey = this.props.routeKey;
                    let url = `/${routeKey}/examineeList/detail/${record.examineeId}`;
                    return <Link to={{ pathname: url, state: 'back'}}>{i18n?.t('view')}</Link>
                }
            },
        ]
    }

    state = {
        pageNum: 1,
        pageSize: 10,
        nickname: '',
    }

    timeId;
    componentDidMount() {
        let data = {
            pageNum: 1,
            pageSize: 10,
        }
        const { history } = this.props;
        if (history.action === 'POP') {
            let pageNumLocal = localStorage.getItem('pageNum-user');
            let pageSizeLocal = localStorage.getItem('pageSize-user');
            if (pageNumLocal && pageSizeLocal) {
                data.pageSize = +pageSizeLocal;
                data.pageNum = +pageNumLocal;
            }
            else {
                localStorage.setItem('pageNum-user', data.pageNum.toString());
                localStorage.setItem('paageSize-user', data.pageSize.toString());
            }
            this.setState({
                pageSize: data.pageSize,
                pageNum: data.pageNum,
            })
        }
        else {
            localStorage.setItem('pageNum-user', data.pageNum.toString());
            localStorage.setItem('paageSize-user', data.pageSize.toString());
        }
        this.props.getExamineeList(data);
        this.props.getTemplate();
    }

    componentWillUnmount() {
        if (this.timeId) {
            clearInterval(this.timeId);
        }
    }

    onPageChange = (pageNum, pageSize) => {
        const {
            nickname,
        } = this.state;
        let page = {
            pageNum: pageNum,
            pageSize: pageSize,
            nickname,
        };
        this.setState(page);
        this.props.getExamineeList(page);
        localStorage.setItem('pageNum-user', pageNum);
        localStorage.setItem('pageSize-user', pageSize);
    }

    onSearch = (formdata) => {
        const pageSize = this.state.pageSize;
        let data = {
            pageNum: 1,
            pageSize: pageSize,
            ...formdata,
        }
        this.setState(data);
        this.props.getExamineeList(data);
        localStorage.setItem('pageNum-user', '1');
        localStorage.setItem('pageSize-user', pageSize.toString());
    }

    onReset = () => {
        const pageSize = this.state.pageSize;
        let data = {
            pageNum: 1,
            pageSize: pageSize,
            nickname: '',
        }
        this.setState(data);
        this.props.getExamineeList(data);
        localStorage.setItem('pageNum-user', '1');
        localStorage.setItem('pageSize-user', pageSize.toString());
    }

    onUploadFile = (file, fileList) => {
        console.log(file);
        this.props.importExaminee(file)
        return false;
    }

    render() {

        let data = this.props.examineeList || {};
        let list = data.examinees || [];
        let total = +(data.totalElements || '0');
        const i18n = this.props.i18n;
        this.returnColumns();

        const url = this.props.examineeExcelTemplate;

        return (
            <div className="userList model">
                <div className='flex-top'>
                    <SearchForm
                        onSearch={this.onSearch}
                        onReset={this.onReset}
                    />
                    <div className='flex-top-right'>
                        <Upload 
                            showUploadList={false}
                            beforeUpload={this.onUploadFile}
                            className="margin-right-20">
                            <Button icon={<UploadOutlined />}>{i18n?.t('importUser')}</Button>
                        </Upload>
                        {url && <a href={url} download>{i18n?.t('downloadImportTemplate')}</a>}
                    </div>
                </div>
                <ConfigProvider locale={i18n?.language == 'en' ? enUs : zhCN}>
                    <Table
                        rowKey={(record) => record.examineeId}
                        dataSource={list}
                        columns={this.Columns}
                        pagination={{
                            showSizeChanger: true,
                            total: total,
                            defaultCurrent: data.number ? data.number + 1 : this.state.pageNum,
                            current: data.number ? data.number + 1 : this.state.pageNum,
                            onChange: this.onPageChange,
                            onShowSizeChange: this.onPageChange,
                            showTotal: total => `${i18n?.t('total')} ${total} ${i18n?.t('articles')}`
                        }}
                    />
                </ConfigProvider>
            </div>
        )
    }
}

function mapStateToProps(state: RootState): StateProps {
    return {
        examineeList: state.silizhuExaminee.examineeList,
        examineeExcelTemplate: state.silizhuExaminee.examineeExcelTemplateUrl,
        routeKey: state.user.routeKey,
    }
}

function mapDispatchToProps(dispatch: ThunkDispatch<RootState, null, AnyAction>): DispatchProps {
    return {
        getExamineeList: (data) => {
            dispatch(actionGetExamineeList(data))
        },
        getTemplate: () => {
            dispatch(actionGetExamineeExcelTemplate())
        },
        importExaminee: (data) => {
            dispatch(actionImportExamineesFromExcel(data))
        }
    }
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Index))